import { signOut } from '../../lib/adminAuth';

/**
 * Cierra la sesión administrativa y navega al login.
 *
 * Se comparte entre AdminSidebar y AdminTopbar (ambos ofrecen «Cerrar
 * sesión») para no duplicar la secuencia signOut + redirección.
 */
export default async function logoutAndRedirect(navigate) {
  await signOut();
  navigate('/admin/login', { replace: true });
}
